import * as types from './types';
import createReducer from '../../createReducer';

const initialState = {
  images: [],
  fetchingImages: false,
  fetchingUploadImage: false,
  fetchedUploadImageSuccess: false,
  fetchingDeleteImage: false,
  fetchedDeleteImageSuccess: false,
  fetchingUpdateImage: false,
  fetchedUpdateImageSuccess: false,
};

const filesReducer = createReducer(initialState)({
  // GET IMAGES
  [types.FETCH_IMAGES_REQUEST]: (state) => {
    return {
      ...state,
      fetchingImages: true,
    };
  },
  [types.FETCH_IMAGES_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      images: payload?.data,
      fetchingImages: false,
    };
  },
  [types.FETCH_IMAGES_FAILED]: (state, { error }) => {
    return {
      ...state,
      fetchingImage: false,
    };
  },
  // UPLOAD IMAGE
  [types.FETCH_UPLOAD_IMAGE_REQUEST]: (state) => {
    return {
      ...state,
      fetchingDeleteImage: false,
      fetchedDeleteImageSuccess: false,
      fetchingUpdateImage: false,
      fetchedUpdateImageSuccess: false,
      fetchingUploadImage: true,
      fetchedUploadImageSuccess: false,
    };
  },
  [types.FETCH_UPLOAD_IMAGE_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchingUploadImage: false,
      fetchedUploadImageSuccess: true,
    };
  },
  [types.FETCH_UPLOAD_IMAGE_FAILED]: (state, { error }) => {
    return {
      ...state,
      fetchingUploadImage: false,
      fetchedUploadImageSuccess: true,
    };
  },
  // DELETE IMAGE
  [types.FETCH_DELETE_IMAGE_REQUEST]: (state) => {
    return {
      ...state,
      fetchingUploadImage: false,
      fetchedUploadImageSuccess: false,
      fetchingUpdateImage: false,
      fetchedUpdateImageSuccess: false,
      fetchingDeleteImage: true,
      fetchedDeleteImageSuccess: false,
    };
  },
  [types.FETCH_DELETE_IMAGE_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchingDeleteImage: false,
      fetchedDeleteImageSuccess: true,
    };
  },
  [types.FETCH_DELETE_IMAGE_FAILED]: (state, { error }) => {
    return {
      ...state,
      fetchingDeleteImage: false,
      fetchedDeleteImageSuccess: true,
    };
  },
  // DELETE IMAGE
  [types.FETCH_UPDATE_IMAGE_REQUEST]: (state) => {
    return {
      ...state,
      fetchingUploadImage: false,
      fetchedUploadImageSuccess: false,
      fetchingDeleteImage: false,
      fetchedDeleteImageSuccess: false,
      fetchingUpdateImage: true,
      fetchedUpdateImageSuccess: false,
    };
  },
  [types.FETCH_UPDATE_IMAGE_SUCCESS]: (state) => {
    return {
      ...state,
      fetchingUpdateImage: false,
      fetchedUpdateImageSuccess: true,
    };
  },
  [types.FETCH_UPDATE_IMAGE_FAILED]: (state) => {
    return {
      ...state,
      fetchingUpdateImage: false,
      fetchedUpdateImageSuccess: true,
    };
  },
  // RESET UPLOAD IMAGE
  [types.RESET_UPLOAD_IMAGE_SUCCESS]: (state) => {
    return {
      ...state,
      loading: false,
      fetchingUploadImage: false,
      fetchedUploadImageSuccess: false,
    };
  },
});

export default filesReducer;
